module.exports = __webpack_public_path__ + "img/em1.b1ca219a.jpg";